import getCardinalPointFromStoneId from '../helpers/getCardinalPointFromStoneId';
import northImage from '../images/north-elevation.png';
import eastImage from '../images/east-elevation.png';
import southImage from '../images/south-elevation.png';
import westImage from '../images/west-elevation.png';

export default function WallImage(props) {
  let imgSrc, imgAlt;
  // eslint-disable-next-line
  switch (getCardinalPointFromStoneId(props.stoneId)) {
    case 'North':
      imgSrc = northImage;
      imgAlt = 'North Side';
      break;
    case 'East':
      imgSrc = eastImage;
      imgAlt = 'East Side';
      break;
    case 'South':
      imgSrc = southImage;
      imgAlt = 'South Side';
      break;
    case 'West':
      imgSrc = westImage;
      imgAlt = 'West Side';
      break;
  }

  return (
    <img
      src={imgSrc}
      alt={imgAlt}
      className="img-fluid w-100"
      width="470"
      height="368"
    />
  );
}
